import React, { Component } from 'react';
import Select from '../../common/select';
import {AddService} from '../../partial/newAddService';
import {TemplateList} from './TemplateList';
import _ from 'lodash';
import BootstrapTable from 'react-bootstrap-table-next';
import "react-bootstrap-table/css/react-bootstrap-table.css";

import { HTTPService } from "../../../services/httpService";

const API = new HTTPService();

export default class Services extends Component {

    state = {
        categories : [] ,
        selectedCategory : "Category",
        services : [] ,
        allServices : [],
        serviceValues : [],
        selectedService : "Service",
        errors : {},
        message : "",
        showModal : false,
        modalAction : "",
        // Current master service info
        currentMasterServiceId : null,
        retailPrices : { L: 0, M: 0, S: 0 },
        wholesalePrices : { L: 0, M: 0, S: 0 },
        duration : 0,
        // Template mode toggle
        isTemplateMode : false
    }

    async componentDidMount() {
        // Load all categories for this installer
        let categoriesRequest = "/categories/" + this.props.typeId;        
        const { data : categories } = await API.get(categoriesRequest);
        this.setState({ categories, selectedCategory : "Category" });  
    };

    // Load services for selected category
    readServices = async (category) => {
        let servicesRequest = "/categoryServices/" + this.props.typeId + "/" + category;        
        const { data : services } = await API.get(servicesRequest);
        
        // Group services by master_service_id and get unique descriptions
        const masterServiceGroups = {};
        services.forEach(service => {
            const masterId = service.master_service_id;
            if (!masterServiceGroups[masterId]) {
                masterServiceGroups[masterId] = {
                    master_service_id: masterId,
                    description: service.description,
                    service_category: service.service_category,
                    duration_days: service.duration_days,
                    services: []
                };
            }
            masterServiceGroups[masterId].services.push(service);
        });
        
        const displayServices = Object.values(masterServiceGroups);
        
        this.setState({ 
            services: displayServices, 
            allServices: services, 
            selectedService: "Service" 
        });  
    }

    // Add service with master service structure
    addService = async (category, description, duration, retailPrices, wholesalePrices = {}) => {
        //console.log("Adding master service:", { category, description, duration, retailPrices, wholesalePrices });
        
        try {
            // Get next master service ID
            let maxMasterServiceRequest = "/maxMasterService/" + this.props.typeId;        
            const { data : lastMasterService } = await API.get(maxMasterServiceRequest);
            const newMasterServiceId = lastMasterService[0].last_service + 1;
            
            //console.log("=== MASTER SERVICE ID DEBUG ===");
            //console.log("Last master service response:", lastMasterService);
            //console.log("New master service ID:", newMasterServiceId);
            //console.log("Type of newMasterServiceId:", typeof newMasterServiceId);
            
            // Get next service ID
            let maxServiceRequest = "/maxService/" + this.props.typeId;        
            const { data : lastService } = await API.get(maxServiceRequest);
            let currentServiceId = lastService[0].last_service;
            
            const vehicleSizes = ['L', 'M', 'S'];
            const catalogs = ['RETAIL'];
            
            // Add wholesale catalog if wholesale prices are provided
            if (wholesalePrices.L || wholesalePrices.M || wholesalePrices.S) {
                catalogs.push('WHOLE');
            }
            
            // Create services for each catalog and vehicle size combination
            for (const catalogType of catalogs) {
                for (const vehicleSize of vehicleSizes) {
                    currentServiceId++;
                    
                    const isWholesale = catalogType === 'WHOLE';
                    const priceSource = isWholesale ? wholesalePrices : retailPrices;
                    
                    let newService = {
                        serviceId: currentServiceId,
                        masterServiceId: newMasterServiceId,
                        serviceCategory: category,
                        description: description,
                        serviceCost: priceSource[vehicleSize] || 0,
                        durationDays: duration,
                        installerId: this.props.typeId,
                        installerCategory: "Paint",
                        vehicleSize: vehicleSize,
                        catalog: catalogType,
                        dataCollect: "N",
                        overrides: "NULL",
                        marketSize: "NULL",
                        notes: "NULL"
                    };
                    
                    //console.log("=== SERVICE OBJECT DEBUG ===");
                    //console.log("Creating service with masterServiceId:", newService.masterServiceId);
                    //console.log("Full service object:", newService);
                    
                    let serviceAdd = "/services";        
                    await API.post(serviceAdd, newService);
                }
            }
            
            alert(`Master service added successfully!`);
            this.setState({showModal : false});
            
            // Refresh and select the newly added service
            await this.refreshAndSelectNewService(category, description);
            
        } catch (error) {
            console.error("Error adding service:", error);
            alert("Error adding service. Please try again.");
        }
    };

    // Helper method to refresh services and select the newly added service
    refreshAndSelectNewService = async (newCategory, newDescription) => {
        try {
            //console.log("Refreshing and selecting new service:", { newCategory, newDescription });
            
            // Load services for the new category
            await this.readServices(newCategory);
            
            // Wait a moment for state to update, then select the new service
            setTimeout(() => {
                // Find and select the newly added service
                const newService = this.state.services.find(service => 
                    service.description === newDescription && 
                    service.service_category === newCategory
                );
                
                if (newService) {
                    // Organize pricing data by catalog and vehicle size
                    const retailPrices = { L: 0, M: 0, S: 0 };
                    const wholesalePrices = { L: 0, M: 0, S: 0 };
                    
                    newService.services.forEach(service => {
                        if (service.catalog === 'RETAIL') {
                            retailPrices[service.vehicle_size] = service.service_cost;
                        } else if (service.catalog === 'WHOLE') {
                            wholesalePrices[service.vehicle_size] = service.service_cost;
                        }
                    });
                    
                    this.setState({
                        selectedCategory: newCategory,
                        selectedService: newDescription,
                        currentMasterServiceId: newService.master_service_id,
                        retailPrices: retailPrices,
                        wholesalePrices: wholesalePrices,
                        duration: newService.duration_days,
                        serviceValues: newService.services
                    });
                    
                    //console.log("New service selected:", newDescription, "in category:", newCategory);
                } else {
                    //console.log("Could not find newly added service to select");
                    // Fallback: just set the category
                    this.setState({
                        selectedCategory: newCategory,
                        selectedService: "Service"
                    });
                }
            }, 100);
            
        } catch (error) {
            console.error("Error refreshing and selecting new service:", error);
            // Fallback: just refresh current category or set to new category
            this.setState({
                selectedCategory: newCategory,
                selectedService: "Service"
            });
            this.readServices(newCategory);
        }
    };

    // Update service with master service structure
    updateService = async (category, description, duration, retailPrices, wholesalePrices = {}) => {
        //console.log("=== UPDATE SERVICE DEBUG ===");
        //console.log("Received parameters:", { category, description, duration, retailPrices, wholesalePrices });
        //console.log("Current master service ID:", this.state.currentMasterServiceId);
        //console.log("Current service values:", this.state.serviceValues);
        
        try {
            const masterServiceId = this.state.currentMasterServiceId;
            if (!masterServiceId) {
                console.error("No master service selected for update");
                alert("No master service selected for update");
                return;
            }
            
            // Get all services for this master service using your updated endpoint
            let masterServicesRequest = `/masterServices/${this.props.typeId}/${masterServiceId}`;
            //console.log("Fetching master services from:", masterServicesRequest);
            
            const { data: masterServices } = await API.get(masterServicesRequest);
            //console.log("Retrieved master services:", masterServices);
            
            // Update each service in the master service group
            for (const service of masterServices) {
                const isWholesale = service.catalog === 'WHOLE';
                const priceSource = isWholesale ? wholesalePrices : retailPrices;
                
                let updatedService = {
                    serviceId: service.service_id,
                    masterServiceId: masterServiceId,
                    serviceCategory: category || service.service_category,
                    description: description || service.description,
                    serviceCost: priceSource[service.vehicle_size] || service.service_cost,
                    durationDays: duration || service.duration_days,
                    installerId: this.props.typeId,
                    installerCategory: service.installer_category,
                    vehicleSize: service.vehicle_size,
                    catalog: service.catalog,
                    dataCollect: service.data_collect,
                    overrides: service.overrides,
                    marketSize: service.market_size,
                    notes: service.notes
                };
                
                //console.log("Updating service:", updatedService);
                
                let serviceUpdate = "/service/" + updatedService.serviceId + "/" + updatedService.installerId;        
                await API.put(serviceUpdate, updatedService);
            }
            
            alert("Master service updated successfully!");
            this.setState({showModal : false});
            
            // Refresh the services list and maintain selection
            await this.refreshAndMaintainSelection(category, description);
            
        } catch (error) {
            console.error("Error updating service:", error);
            alert("Error updating service: " + error.message);
        }
    };

    deleteService = async () => {
    //console.log("=== DELETE SERVICE DEBUG ===");
    //console.log("Current master service ID:", this.state.currentMasterServiceId);
    //console.log("Selected service:", this.state.selectedService);
    
    try {
        const masterServiceId = this.state.currentMasterServiceId;
        if (!masterServiceId) {
            console.error("No master service selected for deletion");
            alert("No master service selected for deletion");
            return;
        }

        // Confirm deletion
        const confirmDelete = window.confirm(
            `Are you sure you want to delete "${this.state.selectedService}"? This will remove all associated pricing (retail/wholesale) for all vehicle sizes. This action cannot be undone.`
        );
        
        if (!confirmDelete) {
            return;
        }

        let serviceDeleteRequest = `/service/${masterServiceId}/${this.props.typeId}`;
        await API.delete(serviceDeleteRequest);

        alert("Service deleted successfully!");

        // Reset state and refresh the category
        const currentCategory = this.state.selectedCategory;
        this.setState({
            selectedService: "Service",
            currentMasterServiceId: null,
            retailPrices: { L: 0, M: 0, S: 0 },
            wholesalePrices: { L: 0, M: 0, S: 0 },
            duration: 0,
            serviceValues: []
        });

        // Refresh services for current category
        if (currentCategory !== "Category") {
            await this.readServices(currentCategory);
        }

    } catch (error) {
        console.error("Error deleting service:", error);

        // Handle backend validation response (service in use)
        if (error.response?.status === 400 && error.response?.data?.message) {
            alert(error.response.data.message);
        } else {
            alert("Error deleting service. Please try again.");
        }
    }
};

// 2. Add confirmation modal method (optional - for better UX)
showDeleteConfirmation = () => {
    if (this.state.selectedService === "Service") {
        alert("Please select a service to delete");
        return;
    }
    
    this.setState({
        showModal: true, 
        modalAction: "delete"
    });
};


    // Helper method to refresh services and maintain the selection
    refreshAndMaintainSelection = async (updatedCategory, updatedDescription) => {
        try {
            // Determine which category to load services for
            const categoryToLoad = updatedCategory || this.state.selectedCategory;
            
            // Reload services for the category
            await this.readServices(categoryToLoad);
            
            // Wait a moment for state to update, then reselect the service
            setTimeout(() => {
                // Find and reselect the updated service
                const serviceToSelect = updatedDescription || this.state.selectedService;
                const selectedMasterService = this.state.services.find(service => service.description === serviceToSelect);
                
                if (selectedMasterService) {
                    // Organize pricing data by catalog and vehicle size
                    const retailPrices = { L: 0, M: 0, S: 0 };
                    const wholesalePrices = { L: 0, M: 0, S: 0 };
                    
                    selectedMasterService.services.forEach(service => {
                        if (service.catalog === 'RETAIL') {
                            retailPrices[service.vehicle_size] = service.service_cost;
                        } else if (service.catalog === 'WHOLE') {
                            wholesalePrices[service.vehicle_size] = service.service_cost;
                        }
                    });
                    
                    this.setState({
                        selectedCategory: categoryToLoad,
                        selectedService: serviceToSelect,
                        currentMasterServiceId: selectedMasterService.master_service_id,
                        retailPrices: retailPrices,
                        wholesalePrices: wholesalePrices,
                        duration: selectedMasterService.duration_days,
                        serviceValues: selectedMasterService.services
                    });
                    
                    //console.log("Service reselected after update:", serviceToSelect);
                } else {
                    //console.log("Could not find updated service to reselect");
                }
            }, 100);
            
        } catch (error) {
            console.error("Error refreshing and maintaining selection:", error);
            // Fallback: just refresh the category
            if (this.state.selectedCategory !== "Category") {
                this.readServices(this.state.selectedCategory);
            }
        }
    };

    showService = async (mode) => {
        this.setState({showModal : true, modalAction: mode});
    };
        
    handleCategoryChange = (event) => {
        const { value } = event.target;      
        this.readServices(value);
        this.setState({
            selectedCategory: value,
            selectedService: "Service",
            serviceValues: []
        });
    }
    
    // Handle service selection and organize pricing data
    handleServiceChange = async (event) => {
        const { value } = event.target;      
        const selectedMasterService = this.state.services.find(service => service.description === value);
        
        if (selectedMasterService) {
            // Organize pricing data by catalog and vehicle size
            const retailPrices = { L: 0, M: 0, S: 0 };
            const wholesalePrices = { L: 0, M: 0, S: 0 };
            
            selectedMasterService.services.forEach(service => {
                if (service.catalog === 'RETAIL') {
                    retailPrices[service.vehicle_size] = service.service_cost;
                } else if (service.catalog === 'WHOLE') {
                    wholesalePrices[service.vehicle_size] = service.service_cost;
                }
            });
            
            this.setState({
                selectedService: value,
                currentMasterServiceId: selectedMasterService.master_service_id,
                retailPrices: retailPrices,
                wholesalePrices: wholesalePrices,
                duration: selectedMasterService.duration_days,
                serviceValues: selectedMasterService.services
            });
        }
    }

    // Toggle between services and templates mode
    handleToggleMode = () => {
        this.setState(prevState => ({ 
            isTemplateMode: !prevState.isTemplateMode,
            selectedCategory: "Category",
            selectedService: "Service",
            services: [],
            allServices: [],
            serviceValues: [],
            currentMasterServiceId: null,
            retailPrices: { L: 0, M: 0, S: 0 },
            wholesalePrices: { L: 0, M: 0, S: 0 },
            duration: 0,
            showModal: false
        }));
    };

    handleCancel = (event) => {
        this.setState({showModal : false})
    }

    render() {  
        // Don't render the main content if in template mode (for now)
        if (this.state.isTemplateMode) {
            return this.renderTemplateMode();
        }

        return this.renderServicesMode();
    }

    renderTemplateMode() {
        return (
            <React.Fragment>
                <h4 className='text-center'>Manage Service Templates</h4>
                
                {/* Mode Toggle Buttons */}
                <div className="text-center mb-3">
                    <div className="btn-group" role="group">
                        <button 
                            type="button"
                            className={`btn ${!this.state.isTemplateMode ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => {
                                if (this.state.isTemplateMode) {
                                    this.handleToggleMode();
                                }
                            }}>
                            Services
                        </button>
                        <button 
                            type="button"
                            className={`btn ${this.state.isTemplateMode ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => {
                                if (!this.state.isTemplateMode) {
                                    this.handleToggleMode();
                                }
                            }}>
                            Templates
                        </button>
                    </div>
                </div>

                {/* Template List Component */}
                <TemplateList typeId={this.props.typeId} />
            </React.Fragment>
        );
    }

    renderServicesMode() {
        // Generate dropdown lists
        var categoryList = this.state.categories.map(a=>a.service_category);
        categoryList.unshift("Category");
        
        var serviceList = this.state.services.map(a=>a.description);
        serviceList.unshift("Service");

        // Table columns - show both retail and wholesale pricing
        const columns = [{
            dataField: 'vehicle_size',
            text: "Size",
            formatter: (cell) => {
                const sizeMap = { L: 'Large', M: 'Medium', S: 'Small' };
                return sizeMap[cell] || cell;
            }
        }, {
            dataField: 'retail_price',
            text: "Retail Price",
            formatter: (cell) => `$${(cell || 0).toFixed(2)}`
        }, {
            dataField: 'wholesale_price',
            text: "Wholesale Price", 
            formatter: (cell) => cell ? `$${cell.toFixed(2)}` : 'Not Available'
        }, {
            dataField: 'savings',
            text: "Wholesale Savings",
            formatter: (cell) => cell ? `$${cell.toFixed(2)}` : '-'
        }, {
            dataField: 'duration_days',
            text: "Duration",
            formatter: (cell) => `${cell} days`
        }];
        
        // Prepare display data for selected service
        let displayData = [];
        if (this.state.selectedService !== "Service") {
            const vehicleSizes = ['L', 'M', 'S'];
            displayData = vehicleSizes.map(size => ({
                vehicle_size: size,
                retail_price: this.state.retailPrices[size],
                wholesale_price: this.state.wholesalePrices[size],
                savings: this.state.retailPrices[size] - (this.state.wholesalePrices[size] || 0),
                duration_days: this.state.duration
            }));
        }

        return (  
            <React.Fragment>
                <h4 className='text-center'>Manage Services Catalog</h4>
                
                {/* Mode Toggle Buttons */}
                <div className="text-center mb-3">
                    <div className="btn-group" role="group">
                        <button 
                            type="button"
                            className={`btn ${!this.state.isTemplateMode ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => {
                                if (this.state.isTemplateMode) {
                                    this.handleToggleMode();
                                }
                            }}>
                            Services
                        </button>
                        <button 
                            type="button"
                            className={`btn ${this.state.isTemplateMode ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => {
                                if (!this.state.isTemplateMode) {
                                    this.handleToggleMode();
                                }
                            }}>
                            Templates
                        </button>
                    </div>
                </div>
                
                {/* Simplified Filter Form */}
                <form className="bg-complete shadow p-4 corners">
                    <div className="form-row justify-content-center">
                        <div className="form-group col-md-3">
                            <Select 
                                name="categories"
                                label=" "
                                options={categoryList}
                                value={this.state.selectedCategory}
                                onChange={this.handleCategoryChange}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <Select 
                                name="services"
                                label=" "
                                options={serviceList}
                                value={this.state.selectedService}
                                onChange={this.handleServiceChange}
                            />
                        </div>
                    </div>
                </form>

                {/* Service Details Table */}
                {this.state.selectedService !== "Service" && (
                    <div className="card text-center mt-3">
                        <div className="card-body">
                            <div className="table-responsive">
                                <BootstrapTable
                                    keyField='vehicle_size'
                                    data={displayData}
                                    columns={columns}
                                    striped
                                    hover
                                    condensed
                                />
                            </div>
                        </div>
                    </div>
                )}
{/* Action Buttons */}
<div className="col text-center mt-3">
    <button 
        type="button" 
        className="btn shadow btn-success m-2 buttons" 
        onClick={() => this.showService("add")}
    >
        ADD NEW SERVICE
    </button>
    {this.state.selectedService !== "Service" && (
        <>
            <button 
                type="button" 
                className="btn shadow btn-primary m-2 buttons" 
                onClick={() => this.showService("update")}
            >
                UPDATE SERVICE
            </button>
            <button 
                type="button" 
                className="btn shadow btn-danger m-2 buttons" 
                onClick={this.deleteService}
            >
                DELETE SERVICE
            </button>
        </>
    )}
</div>
                {/* Service Modal */}
                <AddService
                    show={this.state.showModal}
                    onHide={this.handleCancel}
                    installer={this.props.typeId}
                    category={this.state.selectedService !== "Service" && this.state.serviceValues.length > 0 
                        ? this.state.serviceValues[0].service_category 
                        : this.state.selectedCategory}
                    description={this.state.selectedService}
                    duration={this.state.duration}
                    retailPrices={this.state.retailPrices}
                    wholesalePrices={this.state.wholesalePrices}
                    action={this.state.modalAction}
                    onAdd={this.addService}
                    onUpdate={this.updateService}
                    masterServiceId={this.state.currentMasterServiceId}
                    serviceValues={this.state.serviceValues}
                />
            </React.Fragment>
        );
    }
};